import Field from "./Field";

export default function FFFFStep({ state, update }) {
  return (
    <>
      <Field
        label="Facts"
        hint="What actually happened? No seasoning."
        value={state.s2_facts}
        onChange={(v) => update({ s2_facts: v })}
        testId="field-s2-facts"
        placeholder="Just the plain version."
      />
      <Field
        label="Feelings"
        hint="What came up in me?"
        value={state.s2_feelings}
        onChange={(v) => update({ s2_feelings: v })}
        testId="field-s2-feelings"
        placeholder="Name it plainly. Anger, hurt, disappointment, relief…"
      />
      <Field
        label="Fear"
        hint="What am I afraid this means?"
        value={state.s2_fear}
        onChange={(v) => update({ s2_fear: v })}
        testId="field-s2-fear"
        placeholder={`"This means I'm…", "This means they…"`}
      />
      <Field
        label="Fantasy"
        hint="What am I still hoping is true, even if the facts are not backing it up?"
        value={state.s2_fantasy}
        onChange={(v) => update({ s2_fantasy: v })}
        testId="field-s2-fantasy"
        placeholder="The version you wish were real."
      />
    </>
  );
}
